import * as React from 'react';
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography
} from '@mui/material';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AlertDialogQuestion = ({
  handlePositive,
  handleNegative,
  textButtonPositive = 'Eliminar',
  textButtonNegative = 'Cancelar',
  dialogContentText,
  dialogTitle,
  open,
  elemento,
  showCancelButton = true
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleNegative}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
      maxWidth="xs"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent sx={{ textAlign: 'center', pt: 4, pb: 2 }}>
        <Box sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: '#fef2f2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2
        }}>
          <DeleteOutlineRoundedIcon sx={{ fontSize: 36, color: '#e53935' }} />
        </Box>

        <Typography variant="h6" fontWeight="bold" sx={{ color: '#1a3072', mb: 1 }}>
          {dialogTitle || '¿Eliminar registro?'}
        </Typography>

        <Typography variant="body2" sx={{ color: '#666' }} id="alert-dialog-slide-description">
          {dialogContentText || 'Esta acción no se puede deshacer.'}
        </Typography>

        {elemento}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 3 }}>
        {showCancelButton && (
          <Button
            onClick={handleNegative}
            variant="outlined"
            sx={{ minWidth: 120, borderColor: '#1a3072', color: '#1a3072', '&:hover': { borderColor: '#1a3072', bgcolor: '#f0f4ff' } }}
          >
            {textButtonNegative}
          </Button>
        )}
        <Button
          onClick={handlePositive}
          variant="contained"
          sx={{ minWidth: 120, bgcolor: '#e53935', '&:hover': { bgcolor: '#b71c1c' } }}
        >
          {textButtonPositive}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialogQuestion;
